<template>
  <div class="wrh-dashboard">
    <el-container class="wrh-dashboard-el-container">
      <el-aside width="270px">

        <span
          class="wrh-dashboard-logo"
        />

        <nav-menu
          class="wrh-dashboard-nav-menu"
          @navMenuItemSelected="handleNavMenuItemSelected"
        />

        <space-indicator
          class="wrh-dashboard-space-indicator"
          :used="getStorageSpace.used"
          :total="getStorageSpace.total"
          :indicator-type="getStorageSpace.indicatorType"
        />

      </el-aside>
      <el-container class="wrh-dashboard-el-container">
        <el-header :bordered="false">
          <span
            slot="aside"
            class="centered wrh-el-header-container"
          >

            <el-row class="wrh-dashboard-el-header">
              <el-col
                :span="16"
                class="wrh-dashboard-el-header"
              >

                <span
                  class="el-text el-text--display-medium"
                  v-if="!isActiveContentTable">
                  {{ activeMenuItem.name }}
                </span>

                <content-table-breadcrumbs
                  :menu-item-id="this.activeMenuItem.id"
                  :menu-item-display-name="this.activeMenuItem.name"
                  :archive-id="this.selectedBox.id"
                  :archive-display-name="this.selectedBox.displayName"
                  :is-visible="isActiveContentTable"
                  @breadcrumbItemClick="handleBreadcrumbItemClick"
                />

                &nbsp;
              </el-col>

              <el-col
                :span="6"
                class="wrh-dashboard-el-header"
                style="text-align: right; padding: 0;">
                <el-input
                  v-if="isSearchInputVisible"
                  v-model="searchInputValue"
                  class="mx-16 wrh-dashboard-el-header-search-input"
                  value=""
                  :placeholder="$t('wrh-dashboard.search.input.hint')"
                  suffix-icon="i-search-o--16"
                  size="small"
                  @change="onSearchInputChange"
                  :on-icon-click="onSearchInputIconClick"
                  :disabled="isTableDataLoading"
                  autofocus
                />
              </el-col>

              <el-col
                :span="1"
                class="wrh-dashboard-el-header"
                style="text-align: right; padding: 0;">
                <el-button
                  v-if="getSearchEnabled && !isSearchInputVisible"
                  class="wrh-dashboard-el-header-button"
                  type="ghost"
                  @click="searchButtonClick">
                  <el-icon
                    color="brand-primary"
                    name="i-search-o--24"
                  />
                </el-button>
              </el-col>

              <el-col
                :span="1"
                class="wrh-dashboard-el-header"
                style="text-align: right; padding: 0;">
                <el-button
                  type="ghost"
                  class="wrh-dashboard-el-header-button"
                  @click="helpButtonClick">
                  <el-icon
                    color="brand-primary"
                    name="i-question-circle-o--24"
                  />
                </el-button>
              </el-col>

            </el-row>

          </span>
        </el-header>

        <el-main class="el-main-container">

          <boxes-table
            v-if="isActiveBoxGroup"
            :box-list="getNavMenuItems"
            :sel-box-group="selectedBoxGroup"
            @boxSelected="handleBoxSelected"
            @boxListRefresh="handleBoxListRefresh"
            @cleanupBackup="handleCleanupBackup"
          />

          <content-table
            v-if="isActiveContentTable"
            :content-list="getContentItems"
            :archive-id="selectedBox.id"
            :box-type="selectedBox.type"
            :box-group="selectedBox.group"
            :app-features="getAppFeatures"
            :status-column-hidden="statusColumnHidden"
            :path-column-hidden="!getSearchResultReceived"
            :search-value="searchInputValue"
            @folderSelected="loadContent"
          />

          <shared-content-table
            v-if="isActiveSharedContentTable"
          />

          <account-page
            v-if="isActiveAccountPage"
            :used="getStorageSpace.used"
            :total="getStorageSpace.total"
            :indicator-type="getStorageSpace.indicatorType"
            :user-name="getUserSubscription.userName"
            :subscription-type="getUserSubscription.subscriptionType"
            :expiration-date="getUserSubscription.expirationDate"
            :brand-name="getBrandName"
            @handleCleanUp="handleCleanUpAll"
          />

        </el-main>

      </el-container>
    </el-container>

    <cleanup-component
      :is-cleanup-all="isCleanupAll"
      :cleanup-box="boxToCleanup"
      @goToMenuItem="handleNavMenuItemSelected"
    />

    <password-dialog-box
      v-if="passwordDialogBoxVisible"
      :archive-id="passwordDialogBoxBox.id"
      :box-group="passwordDialogBoxBox.group"
      :archive-display-name="passwordDialogBoxBox.displayName"
      @handleSubmit="handlePasswordSubmit"
      @handleClose="handlePasswordClose"
    />

    <router-view />
  </div>
</template>

<style lang="scss" scoped>
  $wrh-sp-indicator-block-height: 160px;
  $wrh-default-elements-padding: 16px;

  .wrh-dashboard-el-header {
    height: 64px;
    line-height: 64px;
  }

  .wrh-dashboard-el-header-search-input {
    text-align: left;
    max-width: 267px;
    line-height: 32px;
    height: 32px;
    margin-top: 19px;
  }

  .wrh-dashboard-el-header-button {
    line-height: 24px;
    height: 24px;
    width: 24px;
  }

  .wrh-dashboard-logo {
    display: inline-block;
    text-align: left;
    background: url('../assets/logo/wrh-logo-white.svg') no-repeat;
    width: 256px;
    height: 64px;
  }

  .wrh-dashboard-el-container {
    height: 100vh;
  }

  .el-header, .el-footer, .el-main {
    background-color: $av-fixed-white;
  }

  .wrh-dashboard-nav-menu {
    height: calc(100vh - #{$wrh-sp-indicator-block-height});
  }

  .wrh-dashboard-space-indicator {
    padding: $wrh-default-elements-padding;
    height: $wrh-sp-indicator-block-height;
  }

  .el-header {
    position: relative;
    /*background-color: $av-brand-lighter;*/
    line-height: calc(#{$wrh-default-elements-padding} * 4);
  }

  .wrh-el-header-container {
    padding-left: $wrh-default-elements-padding;
    padding-right: $wrh-default-elements-padding;
  }

  /*
  .el-main-container {
    padding: $wrh-default-elements-padding;
  }
  */

  .el-aside {
    background-color: $av-nav-primary;
    color: $av-fixed-primary;
  }

  .centered {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
</style>

<script>
import { createNamespacedHelpers } from 'vuex';

import NavMenu from './NavMenu';
import SpaceIndicator from './SpaceIndicator';
import BoxesTable from './BoxesTable';
import PasswordDialogBox from './PasswordDialogBox';
import ContentTable from './ContentTable';
import SharedContentTable from './SharedContentTable';
import AccountPage from './AccountPage';
import CleanupComponent from './CleanupComponent';
import ContentTableBreadcrumbs from './ContentTableBreadcrumbs';

import {
  PENDING_STATUS,
  COMPLETED_STATUS,
  SUCCESS_STATUS,
  ERROR_STATUS
} from '../store/action-status';

import {
  FETCH_NAV_MENU_ITEMS,
  FETCH_STORAGE_SPACE,
  FETCH_CONTENT_ITEMS,
  SEARCH_CONTENT_ITEMS,
  UPDATE_ACTIVE_CONTENT_TYPE,
  FETCH_USER_SUBSCRIPTION,
  FETCH_FD_LINK,
  UPDATE_ACTIVE_NAV_MENU_ITEM_ID,
  FETCH_CLEANUP_STAGE
} from '../store/action-types';

import {
  BACKUP_GROUP_TYPE,
  CONTENT_TABLE_TYPE,
  SHARED_CONTENT_TABLE_TYPE,
  ACCOUNT_PAGE_CONTENT_TYPE,
  RESOURCES_PAGE_CONTENT_TYPE
} from '../store/active-content-type';

import backupType from '../store/backup-types';
import backupEventCategory from '../store/backup-event-category';
import backupEventAction from '../store/backup-event-action';

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('wrh-dashboard');

export default {
  name: 'WrhDashboard',
  components: {
    NavMenu,
    SpaceIndicator,
    BoxesTable,
    PasswordDialogBox,
    ContentTable,
    SharedContentTable,
    AccountPage,
    CleanupComponent,
    ContentTableBreadcrumbs
  },
  data: function () {
    return {
      selectedBox: { id: '', type: 'BACKUP', group: 'BACKUPS' },
      selectedBoxGroup: '',
      fullScreenLoader: '',
      isFullScreenLoaderActive: false,
      passwordDialogBoxVisible: false,
      passwordDialogBoxBox: '',
      isShowSharedContent: false,
      activeMenuItem: { id: '', name: '' },
      statusColumnHidden: true,
      isCleanupAll: false,
      boxToCleanup: {},
      isSearchInputVisible: false,
      searchInputValue: ''
    };
  },
  computed: {
    ...mapState([
      'navMenuItems',
      'storageSpace'
    ]),
    ...mapGetters([
      'getNavMenuItems',
      'getContentItems',
      'getStorageSpace',
      'getFetchNavMenuItemsStatus',
      'getFetchContentItemsStatus',
      'getPostLoginOpenArchiveId',
      'getPostLoginOpenNavMenuId',
      'getActiveContentType',
      'getFetchSharedContentItemsStatus',
      'getUserSubscription',
      'getAppFeatures',
      'getFdLink',
      'getFetchFdLinkStatus',
      'getSearchEnabled',
      'getBrandName',
      'getCleanupStatus',
      'getArchiveDeletionStatus',
      'getSearchResultReceived',
      'getActiveVolumePath',
      'getActiveFolderItem'
    ]),
    isTableDataLoading() {
      return this.getFetchContentItemsStatus === PENDING_STATUS;
    },
    isActiveBoxGroup() {
      return this.getActiveContentType === BACKUP_GROUP_TYPE;
    },
    isActiveContentTable() {
      return this.getActiveContentType === CONTENT_TABLE_TYPE;
    },
    isActiveSharedContentTable() {
      return this.getActiveContentType === SHARED_CONTENT_TABLE_TYPE;
    },
    isActiveAccountPage() {
      return this.getActiveContentType === ACCOUNT_PAGE_CONTENT_TYPE;
    }
  },
  watch: {
    getFetchFdLinkStatus(status) {
      if (status === COMPLETED_STATUS) {
        window.location.href = this.getFdLink;
      }
    },
    getFetchNavMenuItemsStatus(status) {
      this.changeLoadingState(status);
    },
    getPostLoginOpenArchiveId(archive) {
      const archiveId = this.searchArchiveId(archive);
      if (archiveId !== '') {
        if (archiveId.group !== undefined && archiveId.group !== '') {
          this.handleNavMenuItemSelected({ id: archiveId.group });
        }
        if (archiveId.options.passwordRequired) {
          this.passwordDialogBoxBox = archiveId;
          this.showPasswordDialogBox(true);
        } else {
          this.handleBoxSelected({
            boxId: archiveId.id
          });
        }
      }
    },
    getPostLoginOpenNavMenuId(menuItem) {
      if (this.selectedBox !== '') {
        this.selectedBox.group = menuItem.id;
      }
      this.handleNavMenuItemSelected(menuItem);
    },
    getCleanupStatus(status) {
      if (status === SUCCESS_STATUS || status === ERROR_STATUS) {
        this.handleBoxListRefresh();
      }
    },
    getArchiveDeletionStatus(status) {
      if (status === COMPLETED_STATUS) {
        this.handleBoxListRefresh();
      }
    },
    getSearchEnabled(enabled) {
      if (!enabled) {
        this.isSearchInputVisible = false;
        this.searchInputValue = '';
      }
    }
  },
  methods: {
    ...mapActions({
      fetchNavMenuItems: FETCH_NAV_MENU_ITEMS,
      fetchStorageSpace: FETCH_STORAGE_SPACE,
      fetchContentItems: FETCH_CONTENT_ITEMS,
      searchContentItems: SEARCH_CONTENT_ITEMS,
      updateActiveContentType: UPDATE_ACTIVE_CONTENT_TYPE,
      fetchUserSubscription: FETCH_USER_SUBSCRIPTION,
      fetchFdLink: FETCH_FD_LINK,
      updateActiveNavMenuItemId: UPDATE_ACTIVE_NAV_MENU_ITEM_ID,
      fetchCleanupStage: FETCH_CLEANUP_STAGE
    }),
    init() {
      this.fetchNavMenuItems();
      this.fetchStorageSpace();
    },
    async handleBoxListRefresh() {
      await this.init();
    },
    searchButtonClick() {
      this.isSearchInputVisible = true;

      this.$gtm.push({
        event: 'Acronis',
        eventCategory: 'WR_backups',
        eventAction: 'Backup_search',
        eventLabel: ''
      });
    },
    helpButtonClick() {
      this.$gtm.push({
        event: 'Acronis',
        eventCategory: 'WR_backups',
        eventAction: 'Help_open',
        eventLabel: ''
      });

      if (this.getOSFamily() === 'Mac') {
        window.open(this.$t('wrh.main-page.link.user-help.mac'), '_blank');
      } else {
        window.open(this.$t('wrh.main-page.link.user-help.win'), '_blank');
      }
    },
    getOSFamily() {
      const app = navigator.appVersion.toLowerCase();
      if (app.indexOf('win') !== -1) return 'Win';
      if (app.indexOf('mac') !== -1) return 'Mac';
      if (app.indexOf('x11') !== -1) return 'Unix';
      if (app.indexOf('linux') !== -1) return 'Linux';
      return 'Unknown';
    },
    handleBoxSelected(selectedItem) {
      this.updateActiveContentType(CONTENT_TABLE_TYPE);
      this.selectedBox = this.getSelectedBox(selectedItem.boxId);
      this.selectedBoxGroup = '';
      this.statusColumnHidden = !this.selectedBox.options.notarized;

      this.loadContent({
        archiveId: selectedItem.boxId,
        path: ''
      });

      const label = backupType(this.selectedBox.type, this.selectedBox.options.notarized).label;
      this.$gtm.push({
        event: 'Acronis',
        eventCategory: backupEventCategory(this.selectedBox.group),
        eventAction: backupEventAction(this.selectedBox.group),
        eventLabel: this.selectedBox.group === 'BACKUPS' ? label : ''
      });
    },
    handleBreadcrumbItemClick(selectedItem) {
      if (selectedItem.menuItem !== undefined) {
        this.handleNavMenuItemSelected(selectedItem.menuItem);
      } else if (selectedItem.isSearchFolder === true) {
        this.onSearchInputChange(selectedItem.crumbTitle);
      } else {
        this.loadContent(selectedItem);
      }
    },
    loadContent(selectedItem) {
      this.fetchContentItems(selectedItem);
    },
    getSelectedBox(boxId) {
      return this.getNavMenuItems.filter(obj => obj.id === boxId)[0];
    },
    searchArchiveId(archive) {
      if (archive.id !== '') {
        const archiveId = this.getNavMenuItems.filter(obj => obj.id === archive.id);
        if (archiveId.length > 0 && archiveId[0] !== 'undefined') {
          return archiveId[0];
        }
      }

      if (archive.baseName !== '') {
        const archiveId = this.getNavMenuItems.filter(obj => obj.baseName === archive.baseName);
        if (archiveId.length > 0 && archiveId[0] !== 'undefined') {
          return archiveId[0];
        }
      }

      return '';
    },
    changeLoadingState(status) {
      if (status === PENDING_STATUS) {
        this.isFullScreenLoaderActive = true;
        setTimeout(() => {
          if (this.isFullScreenLoaderActive) {
            this.showLoading();
          }
        }, 300);
      } else {
        this.isFullScreenLoaderActive = false;
        this.hideLoading();
      }
    },
    showLoading() {
      this.fullScreenLoader = this.$loading({
        background: 'fixed-modal',
        color: 'fixed-white',
        size: '48',
        lock: true
      });
    },
    hideLoading() {
      if (this.fullScreenLoader !== '') {
        this.fullScreenLoader.close();
      }
    },
    showPasswordDialogBox(show) {
      this.passwordDialogBoxVisible = show;
    },
    handlePasswordSubmit(payload) {
      this.showPasswordDialogBox(false);
      this.handleBoxSelected({
        boxId: this.passwordDialogBoxBox.id
      });
    },
    handlePasswordClose() {
      this.showPasswordDialogBox(false);
    },
    handleNavMenuItemSelected(menuItem) {
      this.updateActiveNavMenuItemId(menuItem.id);
      this.activeMenuItem = {
        id: menuItem.id,
        name: this.getHeaderNameByNavMenuItemId(menuItem.id)
      };

      if (menuItem.id === 'resources') {
        this.updateActiveContentType(RESOURCES_PAGE_CONTENT_TYPE);
        this.fetchFdLink();
        return;
      }
      if (menuItem.id === 'shared') {
        this.updateActiveContentType(SHARED_CONTENT_TABLE_TYPE);
        return;
      }
      if (menuItem.id === 'account') {
        this.updateActiveContentType(ACCOUNT_PAGE_CONTENT_TYPE);
        this.fetchStorageSpace();
        this.fetchUserSubscription();
        return;
      }

      this.updateActiveContentType(BACKUP_GROUP_TYPE);
      this.selectedBox = '';
      this.selectedBoxGroup = menuItem.id;
    },
    getHeaderNameByNavMenuItemId(menuItemId) {
      if (menuItemId === 'resources') {
        return this.$t('wrh-dashboard.nav-menu.item.resources');
      }
      if (menuItemId === 'BACKUPS') {
        return this.$t('wrh-dashboard.nav-menu.item.backups');
      }
      if (menuItemId === 'ARCHIVES') {
        return this.$t('wrh-dashboard.nav-menu.item.archives');
      }
      if (menuItemId === 'SYNC') {
        return this.$t('wrh-dashboard.nav-menu.item.sync');
      }
      if (menuItemId === 'MOBILE') {
        return this.$t('wrh-dashboard.nav-menu.item.mobile');
      }
      if (menuItemId === 'shared') {
        return this.$t('wrh-dashboard.nav-menu.item.shared');
      }
      if (menuItemId === 'account') {
        return this.$t('wrh-dashboard.nav-menu.item.account');
      }
      return 'Undefined Menu Item';
    },
    handleCleanupBackup(cleanupBox) {
      this.isCleanupAll = false;
      this.boxToCleanup = cleanupBox;
      this.fetchCleanupStage({
        archiveId: cleanupBox.id
      });
    },
    handleCleanUpAll() {
      this.isCleanupAll = true;
      this.boxToCleanup = {};
      this.fetchCleanupStage({
        archiveId: ''
      });
    },
    onSearchInputIconClick() {
      this.onSearchInputChange(this.searchInputValue);
    },
    onSearchInputChange(value) {
      if (value !== '') {
        this.searchContentItems({
          archiveId: this.selectedBox.id,
          volumePath: this.getActiveVolumePath,
          path: this.getActiveFolderItem.path,
          searchText: value
        });
      }
    }
  },
  async created() {
    await this.init();
  }
};
</script>
